<div class="container-tobbar-sidebar"
    [ngClass]="{'sidebar-closed': is_close_sidebar_menu,'search-mini-show': isShowSearchMini}">
    <div class="nav-topbar">
        <button type="button" class="btn-search-back mr-1" (click)="isShowSearchMini=false">
            <i class="fa fa-arrow-left"></i>
        </button>

        <div class="d-flex align-items-center conteiner-name-menu">
            <div class="btn-close-sidebar mr-2" (click)="btnCloseSidebar()">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
                        stroke="#141416" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </div>
            <div class="title-page py-4">
                {{variableNavSidebar?.titleMenu}}
            </div>
        </div>
        <div>
            <div class="d-flex align-items-center">
                <div class="d-flex container-notif align-items-center br-1 mr-3">
                    <div class="dropdown d-inline-block dropdown-notifikasi p-0" #dropdown="ngbDropdown" ngbDropdown>
                        <button type="button" class=" btn-no-decoration p-0" id="page-header-user-dropdown"
                            ngbDropdownToggle>
                            <div class="btn-notif mt-1">
                                <div style="-webkit-mask: url(assets/icons/icon_Bell.png) center/contain;
                            mask: url(assets/icons/icon_Bell.png) center/contain;" class="iconTopbar">
                                </div>
                                <div class="icon-badge" *ngIf="unmarked_notifications > 0">
                                    {{unmarked_notifications}}
                                </div>
                            </div>
                        </button>
                        <div class="dropdown-menu-right py-3 px-2 conDropdownProfil" ngbDropdownMenu
                            style="border-radius: 5px;">
                            <div class="d-flex justify-content-between px-3 py-3">
                                <div class=" fs-16 text-bold m-0">
                                    Notifikasi
                                </div>
                                <a class="align-middle my-auto text-primary" *ngIf="unmarked_notifications > 0"
                                    (click)="readAllNotif();" role="button">
                                    Baca Semua
                                </a>

                            </div>
                            <hr class="mx-2 my-0">

                            <div class="notifikasi-body mt-1 bt-1">
                                <div class="pl-3 pt-3 pb-2 mt-1 d-flex" role="button" (click)="setExpandMessage(val);"
                                    (mouseover)='showActionNotif(val.id)' (mouseout)='hideActionNotif(val.id)'
                                    [id]="'card-notif-' + val.id" *ngFor="let val of listNotifikasi"
                                    [ngClass]="{'bg-soft-gray': val.marked == false}">
                                    <div class="icon-notifikasi">
                                        <div class="btn btn-soft-warning height-fit-content"
                                            *ngIf="val.reff_type == 'reminder'">
                                            <i class="fas fa-calendar-alt icon-warning"></i>
                                        </div>
                                        <div class="btn btn-soft-danger height-fit-content"
                                            *ngIf="val.reff_type == 'expired'">
                                            <i class="fas fa-calendar-alt icon-danger"></i>
                                        </div>
                                        <div class="btn btn-soft-blue height-fit-content"
                                            *ngIf="val.reff_type == 'comment'">
                                            <i class="fas fa-comment icon-blue"></i>
                                        </div>

                                    </div>
                                    <div class="main-notifikasi">
                                        <div class="text-bold font-size-14">{{val.title}}</div>
                                        <p class="font-size-12"
                                            [innerHTML]="val.is_full || val.message.length < max_length_message ? val.message : (val.message | slice:0:max_length_message) + '...'">
                                        </p>
                                        <div class="pt-1">
                                            <div class="text-semi-bold font-size-12" *ngIf="val.date_diff >= 1">
                                                {{val.date_diff}} hari yang lalu</div>
                                            <div class="text-semi-bold font-size-12" *ngIf="val.date_diff == 0">Hari
                                                ini</div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="listNotifikasi.length < 1">
                                    <div class="p-4 mb-2 text-center">
                                        <i>Data Kosong</i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="garisVertical"></div>
                <div class="d-flex container-profile ml-3">
                    <div class="dropdown d-inline-block" ngbDropdown>
                        <button class="d-flex btn-no-decoration p-0" ngbDropdownToggle>
                            <div>
                                <img class="rounded-circle header-profile-user" *ngIf="userLogin.photo_url"
                                    src="{{userLogin.photo_url}}" alt="User Avatar" />
                                <em *ngIf="!userLogin.photo_url" class="fa fa-user"></em>
                            </div>
                            <div class="px-2 container-name">
                                <div class="ml-1">{{userLogin.name}}</div>
                                <div class="ml-1 text-bold">Admin HR</div>
                            </div>
                            <em class="mdi mdi-chevron-down d-flex align-items-center" style="font-size: 18px;"></em>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                            <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()">
                                <em class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></em>
                                Logout
                            </a>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <div class="main-content">
        <router-outlet></router-outlet>
    </div>

</div>